import { faBan, faFileArrowDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react'
import { Col, Image, Row } from 'react-bootstrap';
import './canceldownloadinvmodal.css'
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import axios from 'axios';
import { toast } from 'react-toastify';
function CancelInvoiceModal({ show, onClose }) {
    const MySwal = withReactContent(Swal);
    const cancelSubscription = () => {
        onClose();
        /* MySwal.fire({
            title: 'Are you sure want to Cancel Subscription?',
            // text: 'You cannot undo this action.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
        } */
        MySwal.fire({
            /*  title: '<strong style="color: white;font-size:16px; margin-top:100px;">Cancel Subscription</strong>',
             html: `<p class="subheading-cancel" style="color: #bcbec0; font-size: 14px; margin-top: 10px;">
            Are you sure you want to Cancel<br/>your Subscription
          </p>`,
             background: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${process.env.PUBLIC_URL}/images/headphone.png) no-repeat center center / cover`,
         */     // text: 'You cannot undo this action.',
            html: `
    <div style="
      padding-top: 40px;
      padding-bottom: 30px;
      background: rgba(0, 0, 0, 0.6);
      border-radius: 20px;
      background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),url(${process.env.PUBLIC_URL}/images/headphone.png) no-repeat center center / cover;
      background-size: cover;
      background-position: center;
      color: white;
    ">
      <h4 style="margin-bottom: 10px;margin-top:35%;font-size:16px;">Cancel Subscription</h4>
      <p style="margin-bottom: 20px; color:#c2c7cc;font-size:14px;">
        Are you sure you want to Cancel your Subscription
      </p>
      <hr/>
     <button id="myswal-cancel" class="myswal-cancel">No</button>
        <button id="myswal-confirm" class="myswal-confirm">Yes</button>
    </div>
  `,

            //   linear-gradient(rgb(48 53 58 / 95%), rgb(34 38 42 / 0.7%))


            // icon: 'warning',
            showCancelButton: false,
            showConfirmButton: false,

            // cancelButtonText: 'No',
            // confirmButtonText: 'Yes',

            // buttonsStyling: false,
            didOpen: () => {
                document.getElementById('myswal-cancel')?.addEventListener('click', () => {
                    // closeCancelModal();
                    Swal.close(); // Optional: Close modal
                });

                document.getElementById('myswal-confirm')?.addEventListener('click', () => {
                    cancelSubscriptionConfirm();
                    Swal.close(); // Optional
                });
            },
            customClass: {
                popup: 'custom-swal-popup',
                // cancelButton: 'custom-cancel-btn',
                // confirmButton: 'custom-confirm-btn',

            },
            background: 'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6))',
            backdrop: 'rgba(0,0,0,0.8)',
        }
        ).then((result) => {
            if (result.isConfirmed) {
                cancelSub()
            }
        });
    }

    /*  const closeCancelModal = () =>{
         alert('no')
         
     } */

    const cancelSubscriptionConfirm = () => {
        cancelSub()




    }
    const cancelSub = async () => {
        try {
            let config = {
                method: 'GET',
                maxBodyLength: Infinity,
                url: `${process.env.REACT_APP_API_URL}/cancel-payu-subscription`,
                headers: {
                    'Authorization': localStorage.getItem('dastaan__token'),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            };
            axios.request(config)
                .then((response) => {
                    console.log(response.data);
                    const msg = response?.data?.msg
                    toast(msg)

                    window.location.reload();
                    // Swal.fire(msg);
                });
        } catch (err) {
        } finally {
        }
    };
    if (!show) return null;
    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
            backgroundColor: 'rgba(0,0,0,75%)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center'
        }}>
            <div className='modal-css'>
                <div className='closeModal' onClick={onClose}>
                    <span className='text-white' >
                        {/* <FontAwesomeIcon icon={faCircleXmark} /> */}
                        <Image className='close-btn'
                            src={`${process.env.PUBLIC_URL}/player_icons/close_player.svg`}
                        />
                    </span>
                </div>
                <Row>
                    <Col md={12} xs={12} xl={12}>
                        <Link to="/download-invoice">
                            <div className='main-div'>
                                <FontAwesomeIcon icon={faFileArrowDown} className='gray-text' /> &nbsp;&nbsp;
                                <span>  Download Invoice</span>
                            </div>
                        </Link>
                    </Col>
                    {
                        localStorage.getItem('is_subscription_cancelled') === 'false' && (<>
                            <Col md={12} xs={12} xl={12}>
                                <Link>
                                    <div className='main-div' onClick={cancelSubscription}>
                                        <FontAwesomeIcon icon={faBan} className='gray-text ml-5' />&nbsp;&nbsp;
                                        <span>  Cancel Subscription</span>
                                    </div>
                                </Link>
                            </Col>
                        </>)
                    }

                </Row>
            </div>
        </div>
    );
}
export default CancelInvoiceModal